import React, {useEffect} from 'react';
import * as Highcharts from 'highcharts';

import defaultTheme from 'themes/Themes/clients/defaultTheme';
import { useMyContext, useAssets } from  'hooks'
import Utils from 'utils/utils';
import { Wrapper } from './styles'

const HigchartsBase = ({ assets, selectedTab }) => {
  const { formatDate, formatCurrency, changeDotToComma } = Utils();
  const { themeType, t } = useMyContext();
  const { generatePeriodString } = useAssets();
  const theme = defaultTheme[themeType];

  const { innerWidth } = window;

  const getTitle = (tab) => {
    switch(tab){
      case 0:
        return t['tabs:Rentability'];
      case 1:
        return t['tabs:Return'];
      case 2:
        return t['tabs:Underwater'];
    }
  }

  const getData = (asset, tab) => {
    switch(tab){
      case 0:
        return asset.rentabilitySeries;
      case 1:
        return asset.returnSeries;
      case 2:
        return asset.drawdownSeries;
    }
  }

  const toolTipValue = (value) => {
    switch(selectedTab){
      case 0:
        return formatCurrency(value);
      case 1:
        return changeDotToComma(value) + '%';
      case 2:
        return changeDotToComma(value) + '%';
    }
  }

  const getType = () => {
    switch(selectedTab){
      case 0:
        return 'line';
      case 1:
        return 'line';
      case 2:
        return 'area';
    }
  }

  useEffect(() => {
    Highcharts.setOptions({
      lang:{
        months: ['Janeiro', 'Fevevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        shortMonths: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        resetZoom: t['chart:resetZoom'],
      },
    })
    Highcharts.chart('line', {
      credits: {
        enabled: false
      },
      chart: {
        style:{
          fontFamily: theme.fonts.primary,
        },
        zoomType: 'x',
        type: getType(),
        backgroundColor: innerWidth <= 920 ? theme.colors[theme.background.quaternary.color][[theme.background.quaternary.intensity]] : 'white',
        events: {
          click: function(e) {
            //TODO: tela de detalhes
          }
        }
      },
      title: {
        text: innerWidth > 920 ? `${getTitle(selectedTab)} - ${generatePeriodString(selectedTab)}` : '',
        align: 'left'
      },
      subtitle: {
          text: document.ontouchstart === undefined ?
              t['chart:desktop:zoom'] : t['chart:mobile:zoom']
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          month: '%b. %y'
        },
        gridLineWidth: 1,
        gridLineColor: innerWidth <= 920 ?  'rgba(255, 255, 255, 0.2)' : 'rgba(51, 51, 51, 0.2)',
        labels: {
          style: {
            color: innerWidth <= 920 ? 'white' : theme.colors[theme.textColors.primary.color][theme.textColors.primary.intensity]
          }
        }
      },
      yAxis: {
        gridLineColor: innerWidth <= 920 ?  'rgba(255, 255, 255, 0.2)' : 'rgba(51, 51, 51, 0.2)',
        title:{
          text: false
        },
        labels: {
          formatter: function(){
            switch(selectedTab){
              case 0:
                return formatCurrency(this.value);
              case 1:
                return `${this.value}%`
              case 2:
                return `${this.value}%`
            }
          },
          style: {
            color: innerWidth <= 920 ? 'white' : theme.colors[theme.textColors.primary.color][theme.textColors.primary.intensity]
          }
        }
      },
      legend: {
        enabled: false
      },
      tooltip: {
        useHTML: true,
        formatter: function () {
          return this.points.reduce(function (s, point) {
              return `${s}<div style="display: flex; width: 100%; justify-content: space-between; margin-top: 16px;"><div style="display: flex; align-items: center;"><div style="display:flex; background-color: ${point.series.color}; width: 8px; height: 8px; margin-right: 4px;"></div> <span style="width: 165px; overflow: hidden; text-overflow: ellipsis;">${point.series.name}</span></div> <span style="display: flex; algin-self: center; font-weight: bold; margin-left: 20px;">${toolTipValue(point.y)}</span> </div>`
          }, '<b style="color: #27618F;">' + formatDate(this.x) + '</b>');
        },
        shared: true,
        crosshairs: true
      },
      plotOptions: {
        line:{
          marker: {
            enabled: false
          }
        },
        area: {
          marker: {
            radius: 2
          },
          states: {
            hover: {
              lineWidth: 1
            }
          },
          threshold: 0
        }
      },
      series: assets.map(asset => 
        ({
          data: getData(asset, selectedTab),
          name: asset.label,
          lineWidth: 3, 
          color: asset.color,
          fillOpacity: 0.2
        })
      )
    });
  }, [assets, selectedTab]);

  return <Wrapper id="line" style={{ height: '450px', backgroundColor: innerWidth <= 920 ? 'none' : 'white' }} />
} 

export default HigchartsBase;